import { useEffect } from "react";
import useShouldAutoPlay from "./shouldAutoPlay";

const useAutoPlay = ({
  videoRef,
  setIsVideoPaused,
  setShouldVideoStayPaused,
}) => {
  const shouldAutoPlay = useShouldAutoPlay();
  const autoPlay = !!videoRef.current && shouldAutoPlay;

  useEffect(() => {
    if (autoPlay) {
      setIsVideoPaused(false);
      setShouldVideoStayPaused(false);
      videoRef.current.play();
    }
  }, [autoPlay]);

  return autoPlay;
};

export default useAutoPlay;
